/* unplugin-vue-components disabled */import { render } from "./collapsed-md-table.vue?vue&type=template&id=67638d8c&scoped=true"
import script from "./collapsed-md-table.vue?vue&type=script&lang=js"
export * from "./collapsed-md-table.vue?vue&type=script&lang=js"

import "./collapsed-md-table.vue?vue&type=style&index=0&id=67638d8c&lang=stylus"
import "./collapsed-md-table.vue?vue&type=style&index=1&id=67638d8c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67638d8c"],['__file',"src/components/md-content/collapsed-md-table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67638d8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67638d8c', __exports__)) {
    api.reload('67638d8c', __exports__)
  }
  
  module.hot.accept("./collapsed-md-table.vue?vue&type=template&id=67638d8c&scoped=true", () => {
    api.rerender('67638d8c', render)
  })

}


export default __exports__